enum UserRole {
  AdminPortal = 'ADMIN_PORTAL',
  AdminCompany = 'ADMIN_COMPANY',
  User = 'USER',
}

Object.freeze(UserRole);
export default UserRole;
